import React, { forwardRef } from "react"
import CreatableSelect from "react-select/creatable"
import { useTranslation } from "react-i18next"

/**
 * Shared creatable react-select wrapper with translated empty-state message.
 */
const TranslatedCreatableSelect = forwardRef(
  function TranslatedCreatableSelect(props, ref) {
    const { t } = useTranslation()
    const { noOptionsMessage, ...rest } = props

    return (
      <CreatableSelect
        ref={ref}
        {...rest}
        noOptionsMessage={
          noOptionsMessage || (() => t("No options"))
        }
      />
    )
  }
)

export default TranslatedCreatableSelect
